/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Close_TicketInputs */

const en_admin_tickets_close_ticket = /** @type {(inputs: Admin_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Ticket`)
};

const zh_admin_tickets_close_ticket = /** @type {(inputs: Admin_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭工单`)
};

/**
* | output |
* | --- |
* | "Close Ticket" |
*
* @param {Admin_Tickets_Close_TicketInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_close_ticket = /** @type {((inputs?: Admin_Tickets_Close_TicketInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Close_TicketInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_close_ticket(inputs)
	return zh_admin_tickets_close_ticket(inputs)
});
export { admin_tickets_close_ticket as "admin.tickets.close_ticket" }